import handler from 'api/handler'

const prefix = '/admin/events'

const methods = {
  fetchAll: args => handler({ method: 'get', url: `${prefix}/fetch`, args }),
  fetchBookings: args => handler({ method: 'get', url: `${prefix}/bookings`, args }),
  updateBookingStatus: args => handler({ method: 'put', url: `${prefix}/bookings/status`, args }),
  updateBookingApproval: args => handler({ method: 'put', url: `${prefix}/bookings/approval`, args }),
  create: args => handler({ method: 'post', url: `${prefix}/create`, args }),
  update: args => handler({ method: 'put', url: `${prefix}/update`, args }),
  delete: id => handler({ method: 'delete', url: `${prefix}/delete/${id}` }),
  uploadImage: formData => handler({ method: 'post', url: `${prefix}/upload-image`, args: formData, isFile: true }),
}

export default methods
